<template>
  <span v-if="icon">
    <v-menu
      v-if="flag && flag.icon && flag.name && flag.tooltip"
      color="grey darken-3"
      class="px-0"
      bottom
      open-on-hover
      nudge-bottom="30"
      max-width="300"
    >
      <v-btn icon slot="activator" @click.stop="" class="ma-0">
        <v-icon class="text-vertical-middle" :color="value.isSevere ? 'error' : 'warning'">
          {{ flag.icon }}
        </v-icon>
      </v-btn>
      <v-card class="grey darken-3">
        <v-card-title class="font-weight-bold pb-0">Flagged: {{ flag.name }}</v-card-title>

        <v-card-text class="pt-1">
          {{ flag.tooltip }}

          <div v-if="value.resolvedAt" class="pt-2">
            <v-icon color="primary" class="text-vertical-middle pr-1" small>
              mdi-checkbox-marked
            </v-icon>
            <span>
              Resolved on {{ new Date(value.resolvedAt) | date('d MMM yyyy') }} at
              {{ new Date(value.resolvedAt) | date('HH:mm') }}
            </span>
          </div>
        </v-card-text>
      </v-card>
    </v-menu>
  </span>
  <span v-else>
    <div class="font-weight-bold">
      <v-icon small class="text-vertical-middle pr-2" :color="value.isSevere ? 'error' : 'warning'">
        {{ flag.icon }}
      </v-icon>
      <span>Flagged: {{ flag.name }}</span>
    </div>
    <div>{{ flag.tooltip }}</div>
    <div v-if="value.resolvedAt" class="pt-2">
      <v-icon color="primary" class="text-vertical-middle pr-1" small>
        mdi-checkbox-marked
      </v-icon>
      <span>
        Resolved on {{ new Date(value.resolvedAt) | date('d MMM yyyy') }} at
        {{ new Date(value.resolvedAt) | date('HH:mm') }}
      </span>
    </div>
  </span>
</template>

<script>
// Data
import flags from '@/data/flags'

// Helpers
import _ from 'lodash'

export default {
  props: { value: Object, icon: { type: Boolean, default: () => false } },

  data() {
    return {
      flags,
    }
  },

  computed: {
    flag() {
      if (!_.get(this, 'flags[0]') || !_.get(this, 'value.key')) return

      return this.flags.find(f => f.key === this.value.key)
    },
  },
}
</script>
